import React, { useEffect, useState, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import APIUrls from '../../services/APIUrls';
import { getAxiosResponse, handleError } from '../../services/authApiRoutes/APImethods';
import { dateConvertToTimeStamp, PROJECT_DATE_FORMAT, dateFormat, timeStamp } from '../../services/Util';
import Select from 'react-select';
import { updateProjectInfo } from '../../redux/reducers/ProjectInfoSlice';
import { updateProjectInfoConfiguration } from '../../redux/reducers/ProjectInfoConfigurationSlice';
import { updateProjectInfoValidation } from '../../redux/reducers/ProjectInfoValidationSlice';
import DatePickerCalendar from '../dashboard/calendars/DatePickerCalendar';
import $, { data } from "jquery";
import { useTranslation } from 'react-i18next';
import Constants from '../../Constants';
import store from "../../redux/store";
import dateUtil from "../../services/DateUtil";
import CreatableSelect from 'react-select/creatable';
import { RotatingLines } from 'react-loader-spinner';

export default function ProjectBasicDetails() {
  const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
  const [projectName, setProjectName] = useState(null);
  const [projectNameLength, setProjectNameLength] = useState('')
  const [projectDescriptionLength, setProjectDescription] = useState('')
  const [minDate, setMinDate] = useState()
  const [workspaceCampaign, setWorkspaceCampaign] = useState([]);
  const [companyGlossaryStatus, setCompanyGlossaryStatusFlag] = useState(false)
  const [intendendUseTaskData, setIntendedUseTask] = useState([{}])
  const [intendend, setIntendendData] = useState(false)
  const [tagsDropdown, setTagsDropdown] = useState([]);
  const [tagsCheck,setTagsCheck]=useState([]);
  const [tagsData, setTagsData] = useState([]);
  const [showCampaigns, setShowCampaigns] = useState(false);
  const [globalOverlay, setGlobalOverlay] = useState(true);
  const customerRedux = store.getState()?.customer_bootstrap_data?.value;
  const customerTimeZone = customerRedux?.user?.timeZone;
  const dispatch = new useDispatch();

  const { t } = useTranslation();
  const translate = t;


  const projectData = useSelector(
    (reduxStore) => reduxStore.project_info
  ).value;
  const projectInfoConfiguration = useSelector(
    (reduxStore) => reduxStore.project_info_configuration_slice
  ).value;

  const errorData = useSelector(
    (reduxStore) => reduxStore.project_info_validation_slice
  ).value;

  const setProjectInfoValidationToRedux = (type, value) => {
    dispatch(updateProjectInfoValidation({
      type: type,
      value: value
    }));
  }
 
  const clearTags = (e, tags) => {
    e.preventDefault();
    let finalTagData = tagsData.filter(data => data !== tags)
    let finalTag = tagsData.filter(data => data === tags)
      setTagsData(finalTagData)
      tagsCheck.forEach(data=>{
        if(data.value===tags){
          setTagsDropdown([...tagsDropdown,{label:finalTag[0],value:finalTag[0]} ])
        }
      })
      dispatchFinalDataToRedux('tags', finalTagData)
      if($(document.activeElement).is(':last-child')){
        $(document.activeElement).closest(".global-dropdown-block").find('.global-dropdown-select input:first-of-type').trigger('focus');
      }
      const selectedElement = $(document.activeElement).closest('.global-dropdown-block').find(".multiselect-output");
      if($(document.activeElement).is(':last-child') &&
        selectedElement.children().length > 1){
          selectedElement.find('button:nth-last-child(2)').trigger('focus');
      } else if($(document.activeElement).is(':last-child')){
        $(document.activeElement).closest(".global-dropdown-block").find('.global-dropdown-select input:first-of-type').trigger('focus');
      }
  }
  const refCalendar = useRef(null);

  const refToggle = useRef(null);

  const [toggle, toggleCal] = useState(false);

  const closeCalendar = (e) => {
    if (e.code === "Escape") {
      toggleCal(false);
      $('.cal-firstFocus').trigger('focus');
      $('#cal-firstFocus').removeClass('cal-firstFocus');
    }
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        refCalendar.current &&
        !refCalendar.current?.contains(event.target) &&
        !refToggle.current?.contains(event.target)
      ) {
        toggleCal(false);
      }
    };

    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [refCalendar]);
  const priorities = [
    { value: "HIGHEST", label: translate("project_listing.highest") },
    { value: "HIGH", label: translate("project_listing.high_t") },
    { value: "MEDIUM", label:translate("project_listing.medium_th") },
    { value: "LOW", label:translate("project_listing.low_fo")},
    { value: "LOWEST", label: translate("project_listing.low_fi") },
  ]

  const showCalendarDueDate = (event) => {
    toggle ? toggleCal(false) : toggleCal(true);
    $('#cal-firstFocus').toggleClass('cal-firstFocus')
    if (toggle) {
      var requiredElement = document.querySelector(".dashCalendar");
      requiredElement.focus();
    }
  };


  const setPastCampaign = (event) => {
    if(event.label==='Select a Campaign'){
      dispatchFinalDataToRedux('workspace', { id: 0, name: null, dueDate:false })
    }
    let campaign = event.value;
    setProjectInfoValidationToRedux('pastCampaignStatus', event?.dueDateInPast)
    dispatchFinalDataToRedux('workspace', { id: campaign })
    dispatchFinalDataToReduxInProjectConfigurtation('startCampaign', campaign)
    if (campaign === -1) {
      dispatchFinalDataToRedux('workspace', { id: -1, name: null, dueDate: null })
      return
    }

  }
  const setDueDate = (event) => {
    let previousWorkSpace = projectData?.workspace;
    previousWorkSpace = { ...previousWorkSpace, dueDate: timeStamp(event,customerTimeZone) }
    dispatchFinalDataToRedux('workspace', previousWorkSpace)
    setProjectInfoValidationToRedux('campaignDate', false)
    toggleCal(false);
    $('.cal-firstFocus').trigger('focus')
    $('#cal-firstFocus').removeClass('cal-firstFocus')
   $(document).mouseup(function(e) {
     var bannerCont = $('.caltopset');
     if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
       $('#cal-firstFocus').removeClass('cal-firstFocus')
     }
   });
  }

  $(".cal-firstFocus").on("keydown", function (e) {
    if (e.key === Constants.ESCAPE) {
      if($('div').hasClass('dashCalendar')){
        setTimeout(() => {
          toggleCal(false);
          $('.cal-firstFocus').trigger('focus')
          $('.cal-firstFocus').removeClass('cal-firstFocus')
        }, 100);
      }
    }
    if (e.key === Constants.TAB && e.shiftKey) {
      if($('div').hasClass('dashCalendar')){
        toggleCal(false);
        $('.cal-firstFocus').trigger('focus')
        $('.cal-firstFocus').removeClass('cal-firstFocus')
      }
    }
  });

  const handleChange = (event, occurence) => {
    if (occurence === 'priority') {
      dispatchFinalDataToRedux(occurence, event.value)
    } else if (occurence === 'intendedUse') {
      if (event.value == 0) {
        dispatchFinalDataToRedux(occurence, null)
        setIntendendData(false)
        return
      }
      setProjectInfoValidationToRedux('emptyIntendedUse', false)
      if(intendendUseTaskData && intendendUseTaskData.length > 0){
      intendendUseTaskData.map(data => {
        if (data.value === event?.value) {
          dispatchFinalDataToRedux(occurence, { id: data?.id, name: data?.value });
          let task = event?.tasks?.find((task)=>(task.projectTaskType.type === "update_glossary"));
          if (task) {
            setIntendendData(true);
            dispatchFinalDataToReduxInProjectConfigurtation('intendedName', event?.value);
            dispatchFinalDataToReduxInProjectConfigurtation('updateGlossaryPermission', true);
            setProjectInfoValidationToRedux('glossaryUpdate', false);
          } else {
            setIntendendData(false)
            dispatchFinalDataToReduxInProjectConfigurtation('intendedName', event?.value);
            dispatchFinalDataToReduxInProjectConfigurtation('updateGlossaryPermission', false);
          }
        }

      })
    }

    }
  }
  useEffect(() => {
    const fetchData = async () => {
      let projName = projectData.name;
      if (projName != null && /^Project-\d+$/.test(projName.trim())) { // check if the name is auto generated
        projName = "";
      }
      setProjectName(projName);
      dispatchFinalDataToRedux('name', projName);
      setProjectInfoValidationToRedux('emptyName', false);
      setProjectNameLength(projName);
      setProjectDescription(projectData?.description);
      dispatchFinalDataToReduxInProjectConfigurtation("startCampaign", null);
      try {
        await Promise.all([
          getIntendendUseTask(),
          getAllCampaign(),
          workSpaceTags(),
          updateProjectTags()
        ]);
      } catch (error) {
        handleError(error);
      } finally {
        setGlobalOverlay(false);
      }
    };
  
    fetchData();
  }, [])

  const dispatchFinalDataToRedux = (type, value) => {
    dispatch(updateProjectInfo({
      type: type,
      value: value
    }));
  }

  const dispatchFinalDataToReduxInProjectConfigurtation = (type, value) => {
    dispatch(updateProjectInfoConfiguration({
      type: type,
      value: value
    }));
  }

  const updateProjectTags = async () => {
    if (projectInfoConfiguration.updateGlossaryPermission === true) {
      setIntendendData(true)
      //dispatchFinalDataToReduxInProjectConfigurtation('intendedName', projectData.intendedUse?.name)
    }

  }


  const workSpaceTags = async () => {
    const sortedColumn = 'tagInfo.display';
    const allTagsResponse = await getAxiosResponse(APIUrls.WORKSPACE_TAGS+ `&sortColumn=${sortedColumn}`);
    const allTagsResult = allTagsResponse?.data?.data?.result || [];
  
    let allTagsData = allTagsResult.map(obj => ({
      label: obj.display,
      value: obj.display
    }));
  
    if (projectData?.tags?.length > 0) {
      if (allTagsResult.length > 0) {
        allTagsData = allTagsData.filter(y => !projectData.tags.some(x => x === y.value));
        setTagsData(projectData.tags);
        setTagsCheck(allTagsData);
        setTagsDropdown(allTagsData);
      }
    } else {
      if (allTagsResult.length > 0) {
        setTagsDropdown(allTagsData);
        setTagsCheck(allTagsData);
      }
    }
  }

  const glossaryOptions = projectInfoConfiguration?.departmentName != undefined ? [
    { value: "0", label: "Select One" },
    { value: true, label: "Company Glossary" },
    { value: false, label: `${projectInfoConfiguration?.departmentName?.label} Glossary` }
  ] : [{ label: "Select One", value: "0" }, { value: true, label: "Company Glossary" }]

  const glosaryData = [
    { label: "Select One", value: "0", display: "Select One" },
    { label: "approved", value: "APPROVED", display: "Approved" },
    { label: "needs review", value: "NEEDS_REVIEW", display: "Needs Review" }
  ]


  const companyGlossarySetStatus = (event) => {
    let glossaryStatus = event.value
    if (glossaryStatus === '0') {
      dispatchFinalDataToRedux('projectUpdateGlossary', { generalGlossary: null })
      return
    }
    if (glossaryStatus === true) {
      dispatchFinalDataToRedux('projectUpdateGlossary', { generalGlossary: true })
      setCompanyGlossaryStatusFlag(true)
      setProjectInfoValidationToRedux('glossaryUpdate', false)
      return
    } else if (glossaryStatus !== true) {
      dispatchFinalDataToRedux('projectUpdateGlossary', { generalGlossary: false })
      setCompanyGlossaryStatusFlag(false)
      setProjectInfoValidationToRedux('glossaryUpdate', false)
      return
    }
  }

  const glossaryTermChange = (event) => {
    let finalData = { 'display': event.display, 'code': event.label, 'originalEnum': event.value };
    dispatchFinalDataToRedux('projectUpdateGlossary', { generalGlossary: companyGlossaryStatus, termStatusOnCompletion: finalData })
    if (event.value === '0') {
      dispatchFinalDataToRedux('projectUpdateGlossary', { generalGlossary: companyGlossaryStatus, termStatusOnCompletion: null })
      return
    }
    setProjectInfoValidationToRedux('glossaryStatus', false)
  }


  const campaignNameChange = (event) => {
    setProjectInfoValidationToRedux('campaignName', false)
    let previousWorkSpace = projectData?.workspace;
    previousWorkSpace = { ...previousWorkSpace, name: event.target.value }
    dispatchFinalDataToRedux('workspace', previousWorkSpace)
  }

  const DepartmentProp = {
    PaperProps: {
      style: {
        fontSize: "85.71429%",
        color: aaaSelected ? "white" : "#1C233C",
        background: aaaSelected ? "black" : "#FFF",
      },
      arialabel: "list",
    },
  };


  useEffect(() => {
    setMinDate(new Date().toISOString().slice(0, 10))
    setProjectInfoValidationToRedux(null)
  }, [])


  const getIntendendUseTask = async () => {
    const dateTimestamp = dateConvertToTimeStamp();
    let timeStamp = '?_=' + dateTimestamp
    const intendendUseTask = await getAxiosResponse(APIUrls.INTENDED_USES_TASKS + timeStamp)
    if(intendendUseTask?.data?.data && intendendUseTask?.data?.data.length > 0){
      const intendendUseTaskData = 
      intendendUseTask?.data?.data.map(({ id, name, tasks}) => ({
        label: name,
        value: name,
        id: id,
        tasks: tasks
      }));
      if (intendendUseTaskData) {
        intendendUseTaskData.unshift({
          label: 'Select one',
          value: 0,
          id: 0
        })
      }
      if(projectData?.intendedUse !== null) {
        let showGlossaryUpdateFields = intendendUseTaskData.find(intendedUse => intendedUse.id === projectData?.intendedUse?.id)
        if(showGlossaryUpdateFields?.tasks?.length !== 0) {
          let containsUpdateGlossaryTask = showGlossaryUpdateFields?.tasks?.find(task => task?.projectTaskType?.type === Constants.TASK_UPDATE_GLOSSARY);
          containsUpdateGlossaryTask !== undefined ? setIntendendData(true) : setIntendendData(false);
        }
      }
      setIntendedUseTask(intendendUseTaskData)
    }
  }

  const getAllCampaign = async () => {
    const dateTimestamp = dateConvertToTimeStamp();
    const workspaceQueryParam = `?onlyMember=true&onlyOpen=true&_=${dateTimestamp}`;
    const campaignResult = await getAxiosResponse(APIUrls.WORKSPACE_LIST + workspaceQueryParam);
    const campaignData = campaignResult?.data?.data?.result;
    if(campaignData?.length > 0){
        setShowCampaigns(true);
       const campaignDataResult =campaignResult?.data?.data?.result.map(({ id, name, dueDateInPast }) => ({
        label: name,
        value: id,
        id: id,
        dueDateInPast: dueDateInPast
      }));
      if (campaignDataResult) {
        campaignDataResult.unshift({
          label: translate("project_listing.start_new_campaign"),
          value: -1,
          id: -1,
          dueDateInPast: false
        })
        campaignDataResult.unshift({
          label: translate("project_listing.select_a_campaign"),
          value: 0,
          id: 0,
          dueDateInPast: false
        })
        if( (projectData?.workspace && Object.keys(projectData?.workspace).length > 0) || 
            (projectData?.projectRequest?.workspace && Object.keys(projectData?.projectRequest?.workspace).length > 0)){ 
          let workspaceId = projectData.workspace?.id === -1
            ? campaignData.find(camp => camp.name === projectData.workspace?.name)?.id
            : campaignData.find(camp => camp.id === projectData.workspace?.id)?.id;
          if(workspaceId === undefined){
            workspaceId = campaignData.find(camp => camp.id === projectData?.projectRequest?.workspace?.id)?.id;
          }
          dispatchFinalDataToRedux('workspace', { id: workspaceId });
        }
      }
      setWorkspaceCampaign(campaignDataResult);
    }
    else{
      setShowCampaigns(false);
    }

  }

  const fieldChange = (event) => {
    dispatchFinalDataToRedux(event?.target?.name, event?.target?.value)
    if (event.target.name === 'name') {
      setProjectName(event.target.value);
      setProjectNameLength(event.target.value);
    } else if (event.target.name === 'description') {
      setProjectDescription(event?.target?.value)
    }
    if (projectData.name != '') {
      setProjectInfoValidationToRedux('emptyName', false)
      return;
    }
  }

  const handleTagsChange = (event) => {
		if (event.key === 'Enter' ){
		   event.preventDefault()
       let value=event?.target?.value.trim();
       if(!value) return;
			let finalData=tagsData.filter(data=>data===value)
			if(finalData[0]!==value ){
				setTagsData([...tagsData, value]);
				let tagsDropdownData = tagsDropdown.filter(data => data.value !== value);
				setTagsDropdown(tagsDropdownData)
			  }
		 if (event) {
			dispatchFinalDataToRedux('tags', [...tagsData, value])
		 }
		  }else{
			let value=event[0]?.value
		  if(value && !tagsData.includes(value)){
			setTagsData([...tagsData, value]);
			let tagsDropdownData = tagsDropdown.filter(data => data.value !== value);
			setTagsDropdown(tagsDropdownData)
			if (event) {
				dispatchFinalDataToRedux('tags', [...tagsData, value] )
			}
		  }
		  }
	};

  useEffect(()=>{
    $.each($('.react-calendar__tile'), function( index, value ) {
      $(value).attr('aria-label', value.children[0].ariaLabel);
    });
  },[]);
  return (
    <form>
      <div className="step-3-section">
        <h3>Project Information</h3>
        <div className="project-information flex align-items">
          <div className="flex wrap-dropdown width-32">
            <div className="global-dropdown-block flex-center">
              <label htmlFor='projectName'>{translate("other_integrations_project_creation.project_name")}</label>
              <input
                type="text"
                placeholder="Project Name"
                id="projectName"
                name="name"
                aria-required="true"
                value={projectName}
                onChange={fieldChange}
                maxLength='50'
                className='form-control-sm'
              />
              <small>{isNaN(50 - projectNameLength?.length) ? 39 : 50 - projectNameLength?.length} characters left</small>
              {errorData.emptyName ? <p className='textDanger'>Project Name is required</p> : null}
            </div>

            <div className="global-dropdown-block flex-center">
              <label>{translate("project_listing.priority")} <span>{translate("project_listing.optional")}</span></label>

              <Select className='global-dropdown-select' classNamePrefix='cw'
                menuShouldScrollIntoView={false}
                value={priorities.filter(function (option) {
                  return option.value === projectData?.priority;
                })}
                onChange={event => handleChange(event, 'priority')} aria-label="Priority Optional" name='priority' options={priorities} />
            </div>

            
              

            <div className="global-dropdown-block flex-center" createproject-tour="intended-select">
            <label>{translate("project_listing.intended_use")}</label>


              <Select className='global-dropdown-select requiredInput' classNamePrefix='cw'  menuShouldScrollIntoView={false}
                value={intendendUseTaskData.filter(function (option) {
                  return option.value === projectData?.intendedUse?.name;
                })}
                onChange={event => handleChange(event, 'intendedUse')} aria-label="Intended Use" name='intendedUse' options={intendendUseTaskData} />

              {errorData.emptyIntendedUse ? <p className='textDanger'>Intended Use is required field</p> : null}
            </div>

            {intendend ? <>
              <div className="global-dropdown-block flex-center">
                <label>Glossary to Update</label>

                <Select className='global-dropdown-select' classNamePrefix='cw'
                  value={glossaryOptions.filter(function (option) {
                    return option.value === projectData?.projectUpdateGlossary?.generalGlossary;
                  })}
                  onChange={e => companyGlossarySetStatus(e)} aria-label="Glossary to Update" name='glossaryToUpdate' options={glossaryOptions} />
                {
                  errorData.glossaryUpdate ? <p className='textDanger'>Company Glossary is required field. </p> : null
                }
              </div>


              <div className="global-dropdown-block flex-center" >
                <label>Glossary Term Status On Completion</label>
                <Select className='global-dropdown-select' classNamePrefix='cw'
                  menuShouldScrollIntoView={false}
                  value={glosaryData.filter(function (option) {
                    return option.display === projectData?.projectUpdateGlossary?.termStatusOnCompletion?.display;
                  })}
                  onChange={event => glossaryTermChange(event)} aria-label="Glossary Term Status On Completion" name='glossaryTerm' options={glosaryData} />
                {
                  errorData.glossaryStatus ? <p className='textDanger'>Glossary term status on completion is required field. </p> : null
                }
              </div>
            </> : null}

            <div className="global-dropdown-block flex-center">
              <label>{translate("project_listing.campaign")} <span>{translate("project_listing.optional")}</span></label>
              {showCampaigns ? <><Select 
                  classNamePrefix='cw'  
                  menuShouldScrollIntoView={false} 
                  options={workspaceCampaign} 
                  onChange={setPastCampaign}
                  value={workspaceCampaign.filter(function (option) {
                    return option.value === projectData?.workspace?.id ||
                    option.value === projectData?.projectRequest?.workspace?.id;
                  })}
                  name='workspace' 
                  aria-label="Campaign Optional" 
                  className='global-dropdown-select' 
                />
                {workspaceCampaign.find(data => data?.id === projectData?.workspace?.id)?.dueDateInPast && (
                  <p className='textDanger'>
                    The selected campaign has a due date in the past. If this is incorrect, please select a different campaign.
                  </p>
                )}
              </>
              :
              <div>
                You are not a member or owner of any campaign, so you cannot add this project to a campaign at this time.
              </div> 
            }
            </div> 

            {projectInfoConfiguration?.startCampaign === -1 ? <>
            <div className="global-dropdown-block flex-center" >
              <label htmlFor='cName'>Campaign Name</label>

              <input className='form-control-sm' type="text" aria-required="true" id='cName' onChange={event => campaignNameChange(event)}/>
              {
                errorData.campaignName ? <p className='textDanger' aria-describedby='cName'>Campaign Name is required field</p> : null
              }
            </div>

            <div className="global-dropdown-block flex-center caltopset">
              <label>Campaign Due Date</label>
              <div className="global-dropdown-select">
              <label htmlFor='cal-firstFocus' className='font-zero'>Campaign Due Date</label>
                <button
                  onClick={(e) => {
                    showCalendarDueDate(e);
                  }}
                  id='cal-firstFocus'
									required
                  aria-expanded={toggle ? 'true':'false'}
                  aria-label={toggle ? 'choose date dialog': projectData?.workspace?.dueDate ? `Campaign Due Date ${dateUtil.format(projectData?.workspace?.dueDate,null,null)} selected` : ""}
                  ref={refToggle}
                  tabIndex={0}
                  type="button" className="drop-down-btn gb-dropBtn">
                  <span>{projectData?.workspace?.dueDate ? dateUtil.format(projectData?.workspace?.dueDate,null,null) : ""}</span>
                  <span className="font-zero">{projectData?.workspace?.dueDate ? dateUtil.format(projectData?.workspace?.dueDate,null,null) :"Start Date"}</span>
                  <svg
                    className="calender-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <path
                      d="M12 1.66666H10V0.666662C10 0.578256 9.96492 0.493472 9.90241 0.430959C9.8399 0.368447 9.75511 0.333328 9.66671 0.333328C9.5783 0.333328 9.49352 0.368447 9.431 0.430959C9.36849 0.493472 9.33337 0.578256 9.33337 0.666662V1.66666H4.66671V0.666662C4.66671 0.578256 4.63159 0.493472 4.56908 0.430959C4.50656 0.368447 4.42178 0.333328 4.33337 0.333328C4.24497 0.333328 4.16018 0.368447 4.09767 0.430959C4.03516 0.493472 4.00004 0.578256 4.00004 0.666662V1.66666H2.00004C1.55818 1.66719 1.13456 1.84296 0.822114 2.1554C0.509668 2.46785 0.333903 2.89146 0.333374 3.33333V12C0.333903 12.4419 0.509668 12.8655 0.822114 13.1779C1.13456 13.4904 1.55818 13.6661 2.00004 13.6667H12C12.442 13.6663 12.8657 13.4906 13.1782 13.1781C13.4906 12.8656 13.6664 12.4419 13.6667 12V3.33333C13.6664 2.89141 13.4906 2.46769 13.1782 2.15521C12.8657 1.84272 12.442 1.66701 12 1.66666ZM13 12C13 12.2652 12.8947 12.5196 12.7071 12.7071C12.5196 12.8946 12.2653 13 12 13H2.00004C1.73482 13 1.48047 12.8946 1.29293 12.7071C1.1054 12.5196 1.00004 12.2652 1.00004 12V6.33333H13V12ZM13 5.66666H1.00004V3.33333C1.00004 2.78133 1.44671 2.33333 2.00004 2.33333H4.00004V3.33333C4.00004 3.42173 4.03516 3.50652 4.09767 3.56903C4.16018 3.63154 4.24497 3.66666 4.33337 3.66666C4.42178 3.66666 4.50656 3.63154 4.56908 3.56903C4.63159 3.50652 4.66671 3.42173 4.66671 3.33333V2.33333H9.33337V3.33333C9.33337 3.42173 9.36849 3.50652 9.431 3.56903C9.49352 3.63154 9.5783 3.66666 9.66671 3.66666C9.75511 3.66666 9.8399 3.63154 9.90241 3.56903C9.96492 3.50652 10 3.42173 10 3.33333V2.33333H12C12.2653 2.33333 12.5196 2.43868 12.7071 2.62622C12.8947 2.81376 13 3.06811 13 3.33333V5.66666Z"
                      fill="#3564EB"
                    />
                  </svg>
                </button>
                {errorData.campaignDate ? <p className='textDanger'>Campaign due date is required field</p> : null}

              </div>
              {toggle ? (<div ref={refCalendar}
                onKeyDown={(e) => {
                  closeCalendar(e);
                }}>
                 <DatePickerCalendar
									value={projectData?.workspace?.dueDate?.utcTimestamp?new Date(projectData?.workspace?.dueDate?.utcTimestamp):new Date()}
                  className={"dashCalendar"} 
                  minDate={new Date()} 
									selectDate={setDueDate}
									/>
              </div>) : (
                ""
              )}
            </div>
          </> : null}
          </div>


          <div className="flex wrap-dropdown width-32">
            <div className="global-dropdown-block flex-center">
              <label htmlFor='description'> Project Description
               <span>{translate("project_listing.optional")}</span></label>
              <textarea maxLength='250' name='description' id='description' value={projectData.description ? projectData.description : ""} onChange={event => fieldChange(event)}
                className="textarea" />
              <small>{250 - (projectDescriptionLength?.length ? projectDescriptionLength?.length : 0)} characters left</small>
            </div>
            <div className="global-dropdown-block flex-center">
              <label>{translate("project_listing.tags")} <span>{translate("project_listing.optional")}</span></label>

                 <CreatableSelect
                  className='global-dropdown-select' classNamePrefix='cw'
                  value={tagsDropdown.filter(function (option) {
                    return option?.value === projectData?.tags;
                  })}
                  onChange={(event) => handleTagsChange(event)} aria-label="Tags Optional" 
                  closeMenuOnSelect={true}
                  menuShouldScrollIntoView={false}
                  isMulti
                  options={tagsDropdown}
                  placeholder="Select or enter tag"
                  onMenuOpen={workSpaceTags} 
                   />

              <div className="multiselect-output flex">

               {tagsData &&  tagsData.length > 0 &&
                    tagsData.map(tags => (
                      <button aria-label={'remove ' + tags} onClick={(e) => clearTags(e, tags)}>
                        <strong>{tags}</strong>
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
                          <path d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                        </svg>
                      </button>
                    )
                    )
                  }


              </div>
            </div>
          </div>
          
          

          


          
        </div>
      </div>
      <div>
      </div>
      <div className={globalOverlay ? "gb-overlay show" : "gb-overlay hide"}>
        <div className="gb-loader">
          <RotatingLines strokeColor="#0096FF" strokeWidth="5" width="196" visible={true} />
        </div>
      </div>
    </form>
  )
}
